// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"50":"32151b35","242":"0c39cf11","881":"9fa8cfb8","989":"7a51b90e"}[chunkId] + ".js";
};